import _css from "@emotion/css";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import style from "./ButtonContent.style";

const ButtonContent = ({
  loading,
  IconLeft,
  IconRight,
  children,
  size
}) => {
  if (loading) {
    return ___EmotionJSX(CircularProgress, {
      color: "inherit",
      size: size === 'small' ? 15 : 20
    });
  }

  return ___EmotionJSX("span", {
    css:
    /*#__PURE__*/
    _css([IconLeft || IconRight ? style.content.withIcon : null], "label:ButtonContent;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9CdXR0b24vQnV0dG9uQ29udGVudC9CdXR0b25Db250ZW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNCVSIsImZpbGUiOiIuLi8uLi8uLi8uLi8uLi90bXAvd2ViL2NvbXBvbmVudHMvQnV0dG9uL0J1dHRvbkNvbnRlbnQvQnV0dG9uQ29udGVudC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IENpcmN1bGFyUHJvZ3Jlc3MgZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUvQ2lyY3VsYXJQcm9ncmVzcyc7XG5pbXBvcnQgc3R5bGUgZnJvbSAnLi9CdXR0b25Db250ZW50LndlYi5zdHlsZSc7XG5cbmNvbnN0IEJ1dHRvbkNvbnRlbnQgPSAoe1xuICBsb2FkaW5nLFxuICBJY29uTGVmdCxcbiAgSWNvblJpZ2h0LFxuICBjaGlsZHJlbixcbiAgc2l6ZSxcbn0pID0+IHtcbiAgaWYgKGxvYWRpbmcpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPENpcmN1bGFyUHJvZ3Jlc3NcbiAgICAgICAgY29sb3I9XCJpbmhlcml0XCJcbiAgICAgICAgc2l6ZT17c2l6ZSA9PT0gJ3NtYWxsJyA/IDE1IDogMjB9XG4gICAgICAvPlxuICAgICk7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxzcGFuIGNzcz17W1xuICAgICAgSWNvbkxlZnQgfHwgSWNvblJpZ2h0ID8gc3R5bGUuY29udGVudC53aXRoSWNvbiA6IG51bGwsXG4gICAgXX1cbiAgICA+XG4gICAgICB7SWNvbkxlZnRcbiAgICAgICAgPyA8c3BhbiBjc3M9e3N0eWxlLmljb25Db250YWluZXIubGVmdH0+PEljb25MZWZ0IGNzcz17c3R5bGUuaWNvbi5iYXNlfSAvPjwvc3Bhbj5cbiAgICAgICAgOiBudWxsfVxuICAgICAgPHNwYW4+eyBjaGlsZHJlbiB9PC9zcGFuPlxuICAgICAge0ljb25SaWdodFxuICAgICAgICA/IDxzcGFuIGNzcz17c3R5bGUuaWNvbkNvbnRhaW5lci5yaWdodH0+PEljb25SaWdodCBjc3M9e3N0eWxlLmljb24uYmFzZX0gLz48L3NwYW4+XG4gICAgICAgIDogbnVsbH1cbiAgICA8L3NwYW4+XG4gICk7XG59O1xuXG5CdXR0b25Db250ZW50LmRlZmF1bHRQcm9wcyA9IHtcbiAgSWNvbkxlZnQ6IG51bGwsXG4gIEljb25SaWdodDogbnVsbCxcbn07XG5cbkJ1dHRvbkNvbnRlbnQucHJvcFR5cGVzID0ge1xuICBsb2FkaW5nOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkLFxuICBJY29uTGVmdDogUHJvcFR5cGVzLmVsZW1lbnRUeXBlLFxuICBJY29uUmlnaHQ6IFByb3BUeXBlcy5lbGVtZW50VHlwZSxcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLmlzUmVxdWlyZWQsXG4gIHNpemU6IFByb3BUeXBlcy5vbmVPZihbJ3NtYWxsJywgJ21lZGl1bSddKS5pc1JlcXVpcmVkLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgUmVhY3QubWVtbyhCdXR0b25Db250ZW50KTtcbiJdfQ== */"))
  }, IconLeft ? ___EmotionJSX("span", {
    css: style.iconContainer.left
  }, ___EmotionJSX(IconLeft, {
    css: style.icon.base
  })) : null, ___EmotionJSX("span", null, children), IconRight ? ___EmotionJSX("span", {
    css: style.iconContainer.right
  }, ___EmotionJSX(IconRight, {
    css: style.icon.base
  })) : null);
};

ButtonContent.defaultProps = {
  IconLeft: null,
  IconRight: null
};
ButtonContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  IconLeft: PropTypes.elementType,
  IconRight: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium']).isRequired
};
export default React.memo(ButtonContent);